import React from 'react';
import _ from "underscore";


export default function Sound (props){
    if (!props.playServerSound) return null;
    const childBlocks = _.values(props.blocks).map((Component, id) => <Component.component { ...props } playServerSound = {props.playServerSound} key={id}/>);

    if (childBlocks.length > 0) {
        return (
            <category name='Sound' id='sound' iconclass='category with-icon-paths snap-icon-sound_dual'>
                <label text={"Sound"}/>
                { childBlocks }       
            </category>
        );
    }
    
    return null;
}